const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`, `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`, 6, 101), new Map([[`class`, `o-container--prose o-container--pad`]]), true, false, 6));
            }

            getTemplateName() {
                return `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`, ``);
            }
        }],
        [101, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`, 6);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h2 class="
      `);
                if ((context.has(`color`) ? context.get(`color`) : null)) {
                    this.echo(`        has-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(12, this.source)(...[this.env, (context.has(`color`) ? context.get(`color`) : null), `html`, null, true]));
                    this.echo(`-color
        has-text-color
      `);
                }
                this.echo(`      `);
                if ((context.has(`background_color`) ? context.get(`background_color`) : null)) {
                    this.echo(`        has-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (context.has(`background_color`) ? context.get(`background_color`) : null), `html`, null, true]));
                    this.echo(`-background-color
        has-background
      `);
                }
                this.echo(`    ">
      We share enthusiastically
    </h2>
  `);
            }

            getTemplateName() {
                return `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184');

let template = env.loadTemplate('cf043fa354d4e0c29cc5bc60f898db58da59312ec74d1286964a43281fc93184');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/wordpress/demo/color.twig", args: context }
     );
     return rendered;;
};